import { type BrandInfo } from '../constants'

interface ResolveStmCampaignCodeParams {
  requestUrl: string | undefined
  currentBrand: BrandInfo | null
  brands: BrandInfo[]
  expiredCampaignCodes: string[]
}

/**
 * 只有這些 endpoint 才會在 currentBrand 為 null 時 fallback 到任一已授權品牌的 token，
 * 避免結帳/購物車等品牌特定 API 在 currentBrand 缺失時偷帶錯誤 token。
 */
const CROSS_BRAND_URL_PREFIXES = ['/cross-brand-malls/']

const isCrossBrandRequest = (requestUrl: string | undefined): boolean =>
  CROSS_BRAND_URL_PREFIXES.some(prefix => requestUrl?.includes(prefix) ?? false)

/**
 * 決定 STM API 請求要套用哪個品牌的 token。
 */
export const resolveStmCampaignCode = (params: ResolveStmCampaignCodeParams): string | undefined => {
  const { requestUrl, currentBrand, brands, expiredCampaignCodes } = params

  const fromPath = requestUrl?.match(/\/campaigns\/([^/?]+)/)?.[1]
  if (fromPath) return fromPath

  if (currentBrand) return currentBrand.campaignCode

  /** cross-brand API 後端對任一已授權且未過期品牌的 token 都接受 */
  if (isCrossBrandRequest(requestUrl)) {
    return brands.find(brand => !expiredCampaignCodes.includes(brand.campaignCode))?.campaignCode
  }

  return undefined
}
